module.exports = __webpack_public_path__ + "img/0113.a4923b4b.png";